/**
 * 휴대폰 본인인증 API 헬퍼
 */

export async function fetchPhoneCertState(apiDomain, accessToken) {
  const response = await fetch(`${apiDomain}/auth/cert/check`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();
  return data;
}

export async function isPhoneVerified(apiDomain, accessToken) {
  try {
    const data = await fetchPhoneCertState(apiDomain, accessToken);
    return data?.result === 'ok' && data?.cert_state === 'Y';
  } catch {
    return false;
  }
}

export function markPhoneVerified() {
  localStorage.setItem('isVerified', 'Y');
}

export function clearPhoneVerified() {
  localStorage.removeItem('isVerified');
}

/** 숫자만 추출 후 010-1234-5678 형식으로 표시 */
export function formatPhoneDisplay(value) {
  const digits = String(value || '')
    .replace(/\D/g, '')
    .slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
}

export function normalizePhone(value) {
  return String(value || '').replace(/\D/g, '').slice(0, 11);
}
